import usePagination from '@/hooks/usePagination';
import { Maybe, SortType, UsersFilters } from '@/types/schema';

import { useLearnersQuery } from '../graphql/queries/generated/learners';

function useLearners({
  sort,
  filters,
  pause,
}: {
  sort?: Maybe<SortType[]>;
  filters: UsersFilters;
  pause?: boolean;
}) {
  const { data, isFetching, isFetchingMore, error, refetch, fetchMore, isLoading, totalCount } =
    usePagination(
      useLearnersQuery,
      {
        filters,
        sort,
      },
      {
        edgeKey: 'users',
        requestPolicy: 'cache-and-network',
        pause,
      },
    );

  // todo only for members filter to be applied
  return {
    isLoading,
    isFetching,
    isFetchingMore,
    error,
    learners: data,
    totalCount,
    refetch,
    fetchMore,
  };
}

export default useLearners;
